import AcademicYear from "./container/AcademicYear";

const index = () => {
  return (
    <div className="main-container">
      <AcademicYear />
    </div>
  );
};

export default index;
